import React from 'react';

const DetalleRegistro: React.FC = () => {
    return <>
        <div><h2>Detalle del registro</h2></div>
    </>
}

export default DetalleRegistro;